/**
 * Toast utility - show notifications from anywhere in the app.
 *
 * Usage:
 *   import { toast } from "../utils/toast"
 *   toast("Message here")
 *   toast("Success!", { type: "success" })
 *   toast("Custom delay", { type: "info", delay: 6000 })
 *
 * Or via window (after app loads):
 *   window.toast("Message")
 *   window.toast("Saved!", { type: "success" })
 *
 * @param {string} message - The message to display
 * @param {Object} options - Optional settings
 * @param {string} options.type - Alert style: "primary" | "secondary" | "accent" | "neutral" | "info" | "success" | "warning" | "error" (default: "info")
 * @param {number} options.delay - Auto-dismiss delay in ms (default: 4000, uses controller value)
 */
export function toast(message, options = {}) {
  const { type = "info", delay } = options
  window.dispatchEvent(
    new CustomEvent("toast:show", {
      detail: { message, type, delay }
    })
  )
}
